/*
 * referral (schema)
 */
import { boolean, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { users } from "../user/user.schema"

export const referrals = schema.table("referrals", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- General ---
	companyName: varchar("company_name", { length: 256 }).notNull(),
	contactName: varchar("contact_name", { length: 128 }),
	address: varchar("address", { length: 512 }),
	phoneNumber: varchar("phone_number", { length: 32 }),
	faxNumber: varchar("fax_number", { length: 32 }),
	email: varchar("email", { length: 256 }),
	isPcp: boolean("is_pcp").notNull().default(false),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
	updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
})
